export const projects = [  
  
  {  
    title: "shea on air",
    description: "A solo flute project",
    year: '2025 – 2026',
    type: 'music, worldbuilding',
    tags: ['music', 'design', 'development'],
    context: 'personal',
    link: 'https://sheaon.earth/',
    cover: './img/covers/air.webp',
    target: '_blank',
    case: false,

  },

   {  
    title: "New York Times Advertising",
    description: "House web campaigns",
    year: '2023 - 2026',
    type: 'web design & development',
    tags: ['design', 'development', 'brand'],
    context: 'client',
    link: '/nyta',
    cover: './img/covers/nyt.webp',
    target: '_self',
    case: false,
  },

  // {  
  //   title: "T Brand Studio",
  //   description: "Premium ad products for The New York Times",
  //   year: '2023 - 2026',
  //   type: 'design',
  //   tags: ['design', 'product', 'development', 'brand'],
  //   context: 'client',
  //   link: '/tbrand',
  //   cover: './img/covers/tbrand.webp',
  //   target: '_self',
  // },

       {  
    title: "Band Visuals",
    description: "Artist, album, and event graphics",
    year: '2020 - 2026',
    type: 'animation, graphics, web design & dev',
    tags: ['animation', 'design', 'illustration', 'music', 'development'],
    context: 'client',
    link: '/bands',
    cover: './img/covers/sunny.webp',
    target: '_self',
    case: false,
  },

 

    {  
    title: "Subvert",
    description: "MVP of a collectively owned music marketplace",
    year: '2025',
    type: 'product design',
    tags: ['design', 'music', 'product'],
    context: 'client',
    link: 'https://subvert.fm/',
    cover: './img/covers/subvert.webp',
    target: '_blank',
    case: false,
  },




  //   {  
  //   title: "Jewelry",
  //   description: "Wax and metalwork",
  //   year: '2025',
  //   type: 'Design',
  //   context: 'personal',
  //   link: 'https://linktr.ee/sheaonair',
  //   cover: './img/covers/air.webp',
  //   target: '_blank',
  //   case: false,

  // },

  {  
    title: "A History of My Personal Website",
    description: "Change over time",
    year: '2018 - 2024',
    type: 'web design & development',
    tags: ['development', 'design'],
    context: 'personal',
    link: '/website',
    cover: './img/covers/website.webp',
    target: '_self',
    case: false,

  },


  {  
    title: "Scent Access Memory",
    description: "Imagery for Are.na x Dirt",
    year: '2024',
    type: 'graphics',
    tags: ['design'],
    context: 'client',
    link: '/scent',
    cover: './img/covers/scent.webp',
    target: '_self',
    case: false,
  },

  // {  
  //   title: "Flowers in Motion",
  //   description: "A radio show",
  //   year: '2023',
  //   type: 'music, graphics',
  //   tags: ['music', 'design'],
  //   context: 'personal',
  //   link: '/flowers',
  //   cover: './img/covers/flowers.webp',
  //   target: '_self',
  //   case: false,
  // },

  {  
    title: "Blue Flower Arts",
    description: "Brand identity for a boutique literary agency",
    year: '2021',
    type: 'brand design',
    tags: ['design', 'brand'],
    context: 'client',
    link: '/bfa',
    cover: './img/covers/bfa.webp',
    target: '_self',
  },

  {  
    title: "Altana",
    description: "Search tools for a supply chain database",
    year: '2022',
    type: 'design',
    tags: ['design', 'product'],
    context: 'client',
    link: '/altana',
    cover: './img/covers/altana.webp',
    target: '_self',
  },

  // {  
  //   title: "RISD Student Visa Review",
  //   description: "An online exhibition of interviews with architecture students",
  //   year: '2021',
  //   type: 'web design',
  //   tags: ['design'],
  //   context: 'client',
  //   link: '/student-visa',
  //   cover: './img/covers/risd.webp',
  //   target: '_self',

  // },

    {  
    title: "MakerDAO Community Development",
    description: "An open-source wiki for a global crypto community",
    year: '2020',
    type: 'visual design, brand',
    tags: ['design', 'development', 'product', 'brand'],
    context: 'client',
    link: '/maker',
    cover: './img/covers/maker.png',
    target: '_self',

  },


    {  
    title: "Ink Drawings",
    description: "Sketchbook scans",
    year: '2021 - 2024',
    type: 'illustration',
    tags: ['illustration'],
    context: 'personal',
    link: '/sketch',
    cover: './img/covers/sketch-2.webp',
    target: '_self',
  },

  {  
    title: "Two People in a Room Over Time",
    description: "A series of Risograph prints",
    year: '2019',
    type: 'illustration',
    tags: ['illustration', 'design'],
    context: 'personal',
    link: '/people',
    cover: './img/covers/people.webp',
    target: '_self',

  },

  {  
    title: "I Didn't Ask for the Habit",
    description: "An abstract comic",
    year: '2018',
    type: 'illustration',
    tags: ['illlustration', 'design'],
    context: 'personal',
    link: '/habit',
    cover: './img/covers/habit.webp',
    target: '_self',
  },

  {  
    title: "Digital Drawings",
    description: "Experiments with 3D software, screenshots, and Photoshop",
    year: '2018 - 2020',
    type: 'animation, illustration',
    tags: ['illustration', 'animation'],
    context: 'personal',
    link: '/sketch-digital',
    cover: './img/covers/sketch.webp',
    target: '_self',
  },

];